import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=87066178&scoped=true"
import script from "./ButtonBar.vue?vue&type=script&lang=js"
export * from "./ButtonBar.vue?vue&type=script&lang=js"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=87066178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87066178",
  null
  
)

export default component.exports